import axios2 from '../api/axios';
export const AlertServices = {
    createalert,
    editalert,
    getalertdata,
    deletealert,
    // getDepartment,
    // createdesignation,
    // getDesignations    
}

function createalert(objdata){
    return axios2.post(`/createalert`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function editalert(objdata){
    return axios2.post(`/editalert`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getalertdata({pagination}){
    return axios2.get(`/getalertdata?page=${pagination.page}&limit=${pagination.limit}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}
function deletealert(id){
        return axios2.post(`/deletealert`,id,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })  
}
